import React, { useState, useContext, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import LeftSidebar from "../../components/LeftSidebar/LeftSidebar";
import {DataContext} from "../../../../../context/data/DataContext";
import useResponsive from "../../../../../hooks/useResponsive";
import {Layout} from "antd";
import '../../../../../assets/scss/theme/admin/style.scss';

export const MainLayout: React.FC = () => {
    const dataContext = useContext(DataContext);
    const [sidebarVisible, setSidebarVisible] = useState(true);
    const { isMobile } = useResponsive();

    useEffect(() => {
        if (isMobile) {
            dataContext.setSidebarVisible(false);
        }
    }, [isMobile]);

    const toggleSideBar = () => {
        setSidebarVisible(!sidebarVisible);
    }

    return (
        <Layout id={"admin-theme-wrapper"} className={`app-wrapper admin-theme-wrapper ${dataContext.sidebarVisible ? '' : 'hide-sidebar'}` }>
            <Header toggleSideBar={toggleSideBar} />
            <Layout className="main-layout">
                <LeftSidebar />
                <Layout.Content className="content-wrapper">
                    <div className="main-content">
                        <Outlet />
                    </div>
                    <Footer />
                </Layout.Content>
            </Layout>
        </Layout>
    )
}
